import { IMessageType } from '@/services/signalr/types';
import { IStatusMsg } from '~/api/messages/IStatusMsg';
import { ITripNoteUpdateReqMsg } from '~/api/messages/ITripNoteUpdateReqMsg';
import { ITripNotesReqMsg } from '~/api/messages/ITripNotesReqMsg';
import { ITripNotesRespMsg } from '~/api/messages/ITripNotesRespMsg';

export const TripNoteUpdateReqMsg: IMessageType<ITripNoteUpdateReqMsg, IStatusMsg> = {
  requestName: 'TripNoteUpdateReqMsg',
  responseName: 'StatusMsg',
};

export const TripNotesReqMsg: IMessageType<ITripNotesReqMsg, ITripNotesRespMsg> = {
  requestName: 'TripNotesReqMsg',
  responseName: 'TripNotesRespMsg',
};
